/**
 * Created by AlexanderC on 5/22/15.
 *
 * Bootstrap file loaded by npm as main
 */

'use strict';

var _Event = require('./Event');

module.exports = _Event.Event;


//////////////////
// WEBPACK FOOTER
// ../~/deep-event/lib.compiled/bootstrap.js
// module id = 387
// module chunks = 0